module.exports = __webpack_public_path__ + "img/vincent.922d5ad8.png";